import React from 'react';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import { Constants } from 'utilities/constants';

const longerLabelWidth = 130

const underwriteStatuses = {
  [Constants.PostAcqUnderwriteStatus.SAVED]: {
    text: 'Saved',
    backgroundColor: '#faa307' // Orange
  },
  [Constants.PostAcqUnderwriteStatus.SUBMITTED]: {
    text: 'Submitted',
    backgroundColor: '#67c12e', // Bright green
    colorWaterfall: true
  }
};

export const getChipStatus = (task) => {
  const { taskStatus, underwriteStatus, consumedOn } = task;
  const foundStatus = underwriteStatuses[underwriteStatus];
  if (!foundStatus) {
    console.log(`UnderwriteStatusChip.js - underwriteStatus of ${underwriteStatus} not recognized`);
    return null;
  }
let chipColor = foundStatus.backgroundColor;
  if (foundStatus.colorWaterfall) { // Waterfall the chip color based on other fields
    if (consumedOn != null) { // Task has been consumed
      chipColor = '#408713'; // Dark green
    } // else use underwriteStatus's default
  }

  return {
    backgroundColor: chipColor,
    text: foundStatus.text,
    border: foundStatus.border,
    color: foundStatus.color,
    width: foundStatus.width
  }
}

const UnderwriteStatusChip = ({ classes, style, task }) => {
  if (!task) return null;
  const myStatus = getChipStatus(task);
  if (!myStatus) {
    return null;
  }

  return <Chip
    classes={{
      root: classes.compTypeChip,
      label: classes.label
    }}
    style={{ backgroundColor: myStatus.backgroundColor, color: myStatus.color, border: myStatus.border, width: myStatus.width ?? 111, ...style }}
    label={myStatus.text}
  />
}

const styles = theme => ({
  compTypeChip: {
    height: 18,
    color: '#fff'
  },
  label: {
    overflow: 'initial'
  }
});

export default withStyles(styles)(UnderwriteStatusChip);